/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _call_super = require("@swc/helpers/_/_call_super");
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var Hook = require("./Hook");
var HookCodeFactory = require("./HookCodeFactory");
var AsyncSeriesBailHookCodeFactory = /*#__PURE__*/ function(HookCodeFactory) {
    _inherits._(AsyncSeriesBailHookCodeFactory, HookCodeFactory);
    function AsyncSeriesBailHookCodeFactory() {
        _class_call_check._(this, AsyncSeriesBailHookCodeFactory);
        return _call_super._(this, AsyncSeriesBailHookCodeFactory, arguments);
    }
    _create_class._(AsyncSeriesBailHookCodeFactory, [
        {
            key: "content",
            value: function content(param) {
                var onError = param.onError, onResult = param.onResult, resultReturns = param.resultReturns, onDone = param.onDone;
                return this.callTapsSeries({
                    onError: (i, err, next, doneBreak)=>onError(err) + doneBreak(true),
                    onResult: (i, result, next)=>`if(${result} !== undefined) {\n${onResult(result)}\n} else {\n${next()}}\n`,
                    resultReturns,
                    onDone
                });
            }
        }
    ]);
    return AsyncSeriesBailHookCodeFactory;
}(HookCodeFactory);
var factory = new AsyncSeriesBailHookCodeFactory();
function COMPILE(options) {
    factory.setup(this, options);
    return factory.create(options);
}
function AsyncSeriesBailHook() {
    var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    var hook = new Hook(args, name);
    hook.constructor = AsyncSeriesBailHook;
    hook.compile = COMPILE;
    hook._call = undefined;
    hook.call = undefined;
    return hook;
}
AsyncSeriesBailHook.prototype = null;
module.exports = AsyncSeriesBailHook;
